import { render, staticRenderFns } from "./InterfaceTwo.vue?vue&type=template&id=629ab21a&scoped=true"
import script from "./InterfaceTwo.vue?vue&type=script&lang=js"
export * from "./InterfaceTwo.vue?vue&type=script&lang=js"
import style0 from "./InterfaceTwo.vue?vue&type=style&index=0&id=629ab21a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629ab21a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('629ab21a')) {
      api.createRecord('629ab21a', component.options)
    } else {
      api.reload('629ab21a', component.options)
    }
    module.hot.accept("./InterfaceTwo.vue?vue&type=template&id=629ab21a&scoped=true", function () {
      api.rerender('629ab21a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/applet/setting/decorationPage/library/modules/Goods/ui/InterfaceTwo.vue"
export default component.exports